PegasusTemplate.StyleAttributeMixin = Ember.Mixin.create({
  attributeBindings: ['style'],

  style: '',

  didInsertElement: function(){
    this._super();
    Ember.run.scheduleOnce('afterRender', this, 'parseStyles');
  },

  parseStyles: function(){
    var styles = this.get('styles'),
      parseStyle = PegasusTemplate.Helpers.convertString.fromCSS.toObject,
      template = parseStyle( PegasusTemplate.loadedTemplate().get('globalSettings') ),
      original = parseStyle( this.get('parentView.originalElementStyles') ),
      enforced = parseStyle( this.get('blockStyle') ),
      current,
      style;

    if( this.get('state') !== 'inDOM' || !this.get('element') ){ return ''; }

    current = parseStyle( this.get('element').style.cssText );
    style = PegasusTemplate.Helpers.convertObjects.toCSS([template, original, current, enforced]);
    this.set( 'style', style );

    return style;
  },

  extraStyles: function(){
    if( !this.get('element') ){ return ''; }
    return this.parseStyles();
  },

  stylesDidChange: function(){
    //if( this.get('state') === 'inDOM'){
      Ember.run.scheduleOnce('afterRender', this, 'parseStyles');
    //}
  }.observes('blockStyle')
});

